import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

import ptBR from "./locales/pt-BR/translation.json";
import es from "./locales/es/translation.json";
import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";
import ptPT from "./locales/pt-PT/translation.json";

const resources = {
  "pt-BR": { translation: ptBR },
  es: { translation: es },
  en: { translation: en },
  fr: { translation: fr },
  "pt-PT": { translation: ptPT },
};

i18n.use(reactI18nextModule).init({
  resources,
  fallbackLng: "pt-BR",
  interpolation: { escapeValue: false },
  react: {
    useSuspense: false,
  },
  debug: true,
});

export const t = (key, options) => i18n.t(key, options);

export default i18n;
